import React from 'react';
import { FormattedMessage } from 'react-intl';
import { history } from './../../configuration/store';

class HelpPage extends React.Component {
    render() {
        return (
            <div className="page">
                <div className="row">
                    <div className="col-xs-12">
                        <h4>{HelpPage.meta.label}</h4>
                    </div>
                    <div className="col-xs-12">
                        <span>help info goes here ...</span>
                    </div>
                </div>
            </div>
        );
    }
}

HelpPage.meta = {
    label: <FormattedMessage id={'help'} defaultMessage={'Help'} />,
    icon: 'help_outline',
    action: () => history.push('/help'),
    locations: ['/help']
};

export default HelpPage;



// WEBPACK FOOTER //
// ./src/pages/help/index.jsx